
import { Skeleton } from 'antd';

import './style.scss';


export function CondoWeeksCardSkeleton({ displayButton = true }: { displayButton?: boolean }) {

  return (
    <div className="condo-weeks-card-wrapper skeleton-card-weeks-wrapper">
      <div className="tns-item">
        <div className="card skeleton-card-weeks">
          <Skeleton active paragraph={false} className="skeleton-card-weeks__img" style={{ width: '100%', height: '100%' }} />
          <div className="position-absolute top-100 start-50 translate-middle w-100" style={{ zIndex: 0 }}>
            <div className="card-body text-center bg-mode shadow rounded mx-4 p-3" style={{ display: 'flex', flexDirection: 'column' }}>
              <Skeleton active paragraph={false} className="skeleton-card-weeks__title" style={{ width: '60%' }} />
              <Skeleton active title paragraph={false} style={{ width: '40%', marginBottom: '5px' }} />

              <div style={{ marginTop: '8px', marginBottom: '20px' }}>
                <table className="table table-sm table-bordered align-start p-0 m-0" style={{ fontSize: '0.8em' }}>
                  <thead>
                      <tr>
                          <td className="fw-bold" style={{ width: '105px' }}><Skeleton active title paragraph={false} /></td>
                          <td className="fw-bold" style={{ width: '105px' }}><Skeleton active title paragraph={false} /></td>
                          <td className="fw-bold" style={{ width: '50px' }}><Skeleton active title paragraph={false} /></td>
                          <td className="fw-bold" style={{ width: '105px' }}><Skeleton active title paragraph={false} /></td>
                      </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td><Skeleton active title paragraph={false} /></td>
                      <td><Skeleton active title paragraph={false} /></td>
                      <td><Skeleton active title paragraph={false} /></td>
                      <td><Skeleton active title paragraph={false} /></td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <Skeleton active title paragraph={false} style={{ width: '40%', marginBottom: '5px' }} />

              {displayButton && (
                <Skeleton active title paragraph={false} className="skeleton-card-weeks__button" style={{ width: '70px' }} />)}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
